import styled from 'styled-components';
import { palette } from '@m12s/component-library';
import { WithProps, includeBaseStyle } from './base';

const Display = WithProps(styled.span`
  ${includeBaseStyle}
  font-size: 3rem;
  line-height: 3.5rem;
  color: ${palette.Grey700};
`);

Display.defaultProps = {
  ...Display.defaultProps,
  defaultWeight: 'bold',
};

export { Display };
